import { cn, getCharCount } from "../../lib/utils";

const WordCount = ({ text, limit = 500, className }) => {
  const count = getCharCount(text);
  const isOver = count > limit;

  return (
    <div className={cn("text-[10px] md:text-xs mt-1 text-right", className)}>
      <span
        className={cn(
          "font-medium",
          isOver ? "text-red-500 animate-pulse" : count > limit * 0.9 ? "text-amber-500" : "text-slate-400 dark:text-slate-500"
        )}
      >
        {count} / {limit} characters
      </span>
      {isOver && <p className="text-red-500 mt-0.5 font-bold">Character limit exceeded!</p>}
    </div>
  );
};

export default WordCount;
